import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
// modukes
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '@components/components/loader/loader.component';
import { NoticeStateComponent } from '@components/components/notice-state/notice-state.component';
import { TranslatorComponent } from '@components/components/translator/translator.component';
import { ZoomComponent } from '@components/components/zoom/zoom.component';
import { TextCopyDirective } from '@components/partials/docs-sections/icons/text-copy.directive';
// app component
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { ButtonComponent } from './components/button/button.component';
import { CardComponent } from './components/card/card.component';
import { ControlsComponent } from './components/controls/controls.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { IconComponent } from './components/icons/icons.component';
import { InputComponent } from './components/input/input.component';
import { InViewComponent } from './components/inview/inview.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
// design system components
import { LogoComponent } from './components/logo/logo.component';
import { MenuDashboardComponent } from './components/menu-dashboard/menu-dashboard.component';
import { MenuV2Component } from './components/menu-v2/menu-v2.component';
import { MenuComponent } from './components/menu/menu.component';
import { ModalActionsComponent } from './components/modal-actions/modal-actions.component';
import { ModalComponent } from './components/modal/modal.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SpDropdownComponent } from './components/sp-dropdown/sp-dropdown.component';
import { SpSelectComponent } from './components/sp-select/sp-select.component';
import { SpTextareaComponent } from './components/sp-textarea/sp-textarea.component';
import { SpToastrComponent } from './components/sp-toastr/sp-toastr.component';
import { StepsComponent } from './components/steps/steps.component';
import { TabComponent } from './components/tab/tab.component';
import { TableBodyCellComponent } from './components/table/components/table-body-cell/table-body-cell.component';
import { TableBodyRowExtendedComponent } from './components/table/components/table-body-row-extended/table-body-row-extended.component';
import { TableBodyRowFormComponent } from './components/table/components/table-body-row-form/table-body-row-form.component';
import { TableBodyRowComponent } from './components/table/components/table-body-row/table-body-row.component';
import { TableBodyComponent } from './components/table/components/table-body/table-body.component';
import { TableFiltersComponent } from './components/table/components/table-filters/table-filters.component';
import { TableFooterComponent } from './components/table/components/table-footer/table-footer.component';
import { TableHeadCellComponent } from './components/table/components/table-head-cell/table-head-cell.component';
import { TableHeadComponent } from './components/table/components/table-head/table-head.component';
import { BasicSearchPipe, FilterByDatePipe, SearchColumnPipe, ServerSearchPipe } from './components/table/table-pipes/table-pipes';
import { TableComponent } from './components/table/table.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { TagsComponent } from './components/tag/tag.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';

// import * as Hammer from 'hammerjs';

@NgModule({
  declarations: [
    LoadingSpinnerComponent,
    LogoComponent,
    ButtonComponent,
    DatePickerComponent,
    InputComponent,
    SpSelectComponent,
    ControlsComponent,
    IconComponent,
    MenuComponent,
    MenuV2Component,
    MenuDashboardComponent,
    SpToastrComponent,
    SpTextareaComponent,
    TabsComponent,
    TabComponent,
    StepsComponent,
    PaginationComponent,
    ModalComponent,
    ModalActionsComponent,
    TagsComponent,
    CardComponent,
    TooltipComponent,
    LoadingSpinnerComponent,
    // tables
    TableComponent,
    TableFiltersComponent,
    TableHeadComponent,
    TableHeadCellComponent,
    TableBodyComponent,
    TableBodyRowComponent,
    TableBodyCellComponent,
    TableBodyRowFormComponent,
    TableBodyRowExtendedComponent,
    TableFooterComponent,
    SpDropdownComponent,
    TranslatorComponent,
    LoaderComponent,
    NoticeStateComponent,
    ZoomComponent
  ],
  exports: [
    LoadingSpinnerComponent,
    LogoComponent,
    ButtonComponent,
    DatePickerComponent,
    InputComponent,
    SpSelectComponent,
    ControlsComponent,
    IconComponent,
    MenuComponent,
    MenuV2Component,
    MenuDashboardComponent,
    SpToastrComponent,
    SpTextareaComponent,
    TabsComponent,
    TabComponent,
    StepsComponent,
    PaginationComponent,
    ModalComponent,
    ModalActionsComponent,
    InViewComponent,
    TagsComponent,
    CardComponent,
    SearchColumnPipe,
    BasicSearchPipe,
    FilterByDatePipe,
    TooltipComponent,
    SpDropdownComponent,
    SearchColumnPipe,
    BasicSearchPipe,
    FilterByDatePipe,
    TextCopyDirective,
    TooltipComponent,
    // tables
    TableComponent,
    TableFiltersComponent,
    TableHeadComponent,
    TableHeadCellComponent,
    TableBodyComponent,
    TableBodyRowComponent,
    TableBodyCellComponent,
    TableBodyRowFormComponent,
    TableBodyRowExtendedComponent,
    ServerSearchPipe,
    TranslatorComponent,
    LoaderComponent,
    NoticeStateComponent,
    ZoomComponent
  ],
  imports: [
    InViewComponent,
    SearchColumnPipe,
    BasicSearchPipe,
    FilterByDatePipe,
    TextCopyDirective,
    ServerSearchPipe,
    CommonModule,
    RouterModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      timeOut: 1000000,
      preventDuplicates: true
    })
  ],
  providers: [
    UntypedFormBuilder,
    provideHttpClient(withInterceptorsFromDi())

  ]
})
export class ComponentsModule { }